import { useEffect, useState } from 'react';

interface ShootingStar {
    id: number;
    startX: number;
    startY: number;
    duration: number;
}

export function ShootingStars() {
    const [stars, setStars] = useState<ShootingStar[]>([]);

    useEffect(() => {
        const createShootingStar = () => {
            const newStar: ShootingStar = {
                id: Date.now() + Math.random(),
                startX: Math.random() * 100,
                startY: Math.random() * 50,
                duration: 1 + Math.random() * 2,
            };

            setStars((prev) => [...prev, newStar]);

            // Remove star after animation
            setTimeout(() => {
                setStars((prev) => prev.filter((s) => s.id !== newStar.id));
            }, newStar.duration * 1000);
        };

        // Create shooting stars at random intervals
        const interval = setInterval(() => {
            if (Math.random() < 1) {
                createShootingStar();
            }
        }, 800);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
            {stars.map((star) => (
                <div
                    key={star.id}
                    className="absolute w-1 h-1 bg-white rounded-full"
                    style={{
                        left: `${star.startX}%`,
                        top: `${star.startY}%`,
                        animation: `shooting-star ${star.duration}s linear forwards`,
                        boxShadow: '0 0 10px 2px rgba(255, 255, 255, 0.8)',
                    }}
                />
            ))}
            <style>{`
        @keyframes shooting-star {
          0% {
            transform: translate(0, 0) scale(1);
            opacity: 1;
          }
          100% {
            transform: translate(300px, 300px) scale(0);
            opacity: 0;
          }
        }
      `}</style>
        </div>
    );
}
